import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight, hoverOpacity } from '@/utility/theme/animation';

export const ResultCardWrapper = styled.div(
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
    ],
    gridGap: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
    width: '100%',
    marginTop: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const ResultCard = styled.div(
  mq({
    position: 'relative',
    minHeight: '300px',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const Table = styled.table(
  mq({
    width: '100%',
    border: `solid ${defaultTheme.border.color.black}`,
    borderWidth: '1px 0',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const THead = styled.thead(
  mq({
    backgroundColor: defaultTheme.background.mediumGray,
  }),
);

export const ArraivalTableHeader = styled.th(
  mq({
    width: 'calc(100% / 3)',
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'normal',
    textAlign: 'center',
    padding: `${defaultTheme.spacing.xs} 0`,
  }),
);

export const CancelData = styled.div(
  mq({
    height: '66px',
  }),
);

export const RacerInfoWrapper = styled.div(
  mq({
    display: 'grid',
    gridGap: defaultTheme.spacing.s,
    padding: `${defaultTheme.spacing.s} 0`,
  }),
);

export const RacerInfo = styled.div(
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > p': {
      fontWeight: 'bold',
      lineHeight: defaultTheme.font.height.base,
      marginTop: defaultTheme.spacing.s,
    },
  }),
);

export const CardHeader = styled.div(
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const LinkWrapper = styled.div(
  mq({
    marginTop: defaultTheme.spacing.l,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: `${defaultTheme.spacing.s}`,
  }),
);

const linkStyle = {
  padding: `${defaultTheme.spacing.m}`,
  color: defaultTheme.color.secondary,
  fontSize: defaultTheme.font.size.s,
  textAlign: 'center',
  border: `1px solid ${defaultTheme.color.secondary}`,
  borderRadius: defaultTheme.border.radius.s,
};

export const ButtonLink = styled(Link)(() =>
  mq({
    ...linkStyle,
    ...hoverOpacity,
  }),
);

export const DisabledLink = styled.div(() =>
  mq({
    ...linkStyle,
    opacity: defaultTheme.button.opacity.disabled,
  }),
);

export const TextLinkArea = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const TextLink = styled(Link)(() =>
  mq({
    display: 'inline-block',
    color: defaultTheme.color.secondary,
    fontSize: defaultTheme.font.size.s,
    ...hoverHighlight,
  }),
);

export const CancelText = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    color: defaultTheme.text.gray,
  }),
);

export const ResultNotExistText = styled.p(() =>
  mq({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: defaultTheme.text.gray,
    textAlign: 'center',
  }),
);

export const TableRow = styled.tr(() =>
  mq({
    borderBottom: `1px solid ${defaultTheme.border.color.black}`,
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
  }),
);

export const TableData = styled.td(() =>
  mq({
    borderBottom: `1px solid ${defaultTheme.border.color.black}`,
    padding: '10px',
  }),
);

export const TableHeader = styled.th(() =>
  mq({
    width: '80px',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontWeight: 'inherit',
    backgroundColor: defaultTheme.background.mediumGray,
    padding: '10px',
  }),
);
